/**
 * @generated SignedSource<<a3e608f92169bde9e02a07e39432e594>>
 * @relayHash 96dce17396b98402ea852d82fd7ba6ba
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0cc26de84f1d64f1941793801db3e6df205067025012647431441512d2deafb8

import type { ConcreteRequest } from 'relay-runtime';
export type ConfluencePagePdfExportVersion = "V1" | "V2" | "V3" | "%future added value";
export type useCreatePagePdfExportTaskMutation$variables = {
  contentId: string;
};
export type useCreatePagePdfExportTaskMutation$data = {
  readonly confluence_createPdfExportTaskForSingleContent: {
    readonly errors: ReadonlyArray<{
      readonly extensions: {
        readonly errorType: string | null;
        readonly statusCode: number | null;
      } | null;
      readonly message: string | null;
    }> | null;
    readonly exportTaskId: string;
    readonly exportVersion: ConfluencePagePdfExportVersion;
    readonly success: boolean;
  } | null;
};
export type useCreatePagePdfExportTaskMutation = {
  response: useCreatePagePdfExportTaskMutation$data;
  variables: useCreatePagePdfExportTaskMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "kind": "ScalarField",
  "name": "exportTaskId"
},
v4 = {
  "kind": "ScalarField",
  "name": "exportVersion"
},
v5 = {
  "kind": "ScalarField",
  "name": "message"
},
v6 = {
  "kind": "ScalarField",
  "name": "errorType"
},
v7 = {
  "kind": "ScalarField",
  "name": "statusCode"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useCreatePagePdfExportTaskMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "ConfluenceCreatePdfExportTaskForSingleContentPayload",
        "kind": "LinkedField",
        "name": "confluence_createPdfExportTaskForSingleContent",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v7/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useCreatePagePdfExportTaskMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "ConfluenceCreatePdfExportTaskForSingleContentPayload",
        "kind": "LinkedField",
        "name": "confluence_createPdfExportTaskForSingleContent",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  (v6/*: any*/),
                  (v7/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "id"
                      }
                    ],
                    "type": "BulkMutationErrorExtension"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "96dce17396b98402ea852d82fd7ba6ba",
    "id": "0cc26de84f1d64f1941793801db3e6df205067025012647431441512d2deafb8",
    "metadata": {},
    "name": "useCreatePagePdfExportTaskMutation",
    "operationKind": "mutation",
    "text": "mutation useCreatePagePdfExportTaskMutation($contentId:ID!){confluence_createPdfExportTaskForSingleContent(input:{contentId:$contentId}){success,exportTaskId,exportVersion,errors{message,extensions{__typename,errorType,statusCode,...on BulkMutationErrorExtension{id}}}}}"
  }
};
})();

(node as any).hash = "744df54379316c281f95d3307db18404";

export default node;
